export const EVENT_STATUS_DRAFT = 'draft';
export const EVENT_STATUS_PAST = 'past';
export const EVENT_STATUS_CANCELED = 'canceled';
export const EVENT_STATUS_SENDING = 'sending';

export const USED_AS_INVITATION = 'invitation';
export const USED_AS_SAVE_THE_DATE = 'save_the_date';
export const USED_AS_CARD = 'card';
export const USED_AS_GIFT_CARD = 'gift_card';

export const TODDLER_CATEGORY = 'Toddler';
export const GET_TOGETHER_CATEGORY = 'Get Together';
export const BABY_CATEGORY = 'Baby';
export const KIDS_BIRTHDAY_CATEGORY = 'Birthday for Kids';
export const ADULTS_BIRTHDAY_CATEGORY = 'Birthday for Adults';
export const WEDDING_CATEGORY = 'Wedding';
export const GRADUATION_CATEGORY = 'Graduation';
export const FUNERAL_CATEGORY = 'Funeral';

export const FUNERAL_MEMORIAL_EVENT_TYPE = 'funeral_memorial_service';
